import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, newCanalVentaSchema, ROUTER_PATHS } from '@/shared';
import { useCreateCanalVenta, useUpdateCanalVenta } from '@/shared/actions/erp';
import {
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
  TabTextLabel,
} from '@/shared/components/ui';
import { AlertSeverityEnum, CanalVenta } from '@/shared/interfaces';
import { AcutocompletePromocion } from '@/erp/sytem-sttings/promociones/shared/components';
import { DAYS_WEEK_COLLECTION, diasPermitidosInterface, WorkDaysCollection } from '@/shared/interfaces/erp/global/days.interface';
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';
import { getDiasPermitidos, getTimesForClockInWorkSchedules, hoursBetweenRange } from '@/shared/utils/horarios-acceso-usuarios';
import { useUiStore } from '@/store/ui';
export interface SaveCanarVentaInterface {
  titlePage: string;
  editCanalVenta?: CanalVenta;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  supervisor?: string | null;
  estado: boolean;

  // to handle users schedule
  workDays?: number[];
  hora_inicio_jornada?: Date;
  hora_fin_jornada?: Date;
  dias_permitidos?: diasPermitidosInterface[] | [] | null;
  siempre_disponible?: boolean;
};

const returnUrlCanalesVenta = ROUTER_PATHS.administration.canalVentaNav;

const SaveCanarVenta: React.FC<SaveCanarVentaInterface> = ({
  titlePage,
  editCanalVenta,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  // ya no canales de venta
  ///* global state
  const setAlert = useUiStore(s => s.setAlert);

  ///* mutations
  const createCanalVentaMutation = useCreateCanalVenta(
    navigate,
    returnUrlCanalesVenta
  );
  const updateCanalVentaMutation = useUpdateCanalVenta(
    navigate,
    returnUrlCanalesVenta
  );

  ///* fetch data
  // const {
  //   data: supervisoresPagingRes,
  //   isLoading: isLoadingSupervisores,
  //   isRefetching: isRefetchingSupervisores,
  // } = useFetchEmpleados({
  //   enabled: true,
  //   params: {
  //     page_size: 1000,
  //     tipo_empleado: TipoEmpleadoEnumChoice.SUPERVIDOR,
  //   },
  // });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCanalVentaSchema),
    defaultValues: {
      estado: true,
      siempre_disponible: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = async (data: SaveFormData) => {
    if (!isValid) return;

    if (!!form.getValues().siempre_disponible) {
      console.log('siempre disponible',form.getValues().siempre_disponible)
      if (editCanalVenta?.id_canal_venta) {
        return updateCanalVentaMutation.mutate({
          id: editCanalVenta.id_canal_venta,
          data: {
            ...form.getValues() as any,
            dias_permitidos: null
          }, // desc?
        });
      }

      ///* create
      return createCanalVentaMutation.mutate({
        nombre: data.nombre,
        codigo: data.codigo,
        estado: data.estado,
        supervisor: data?.supervisor || (null as any),
        dias_permitidos: null
      });
    }

    const inicio_jornada = form.getValues()?.hora_inicio_jornada
    const fin_jornada = form.getValues()?.hora_fin_jornada

    if (!!!inicio_jornada || !!!fin_jornada || form.getValues().workDays?.length === 0) {
      return setAlert(true, "Complete el Horario del empleado", AlertSeverityEnum.error)
    }

    const hoursToWork = hoursBetweenRange(
      form.getValues()?.hora_inicio_jornada?.getHours(),
      form.getValues()?.hora_fin_jornada?.getHours()
    );
    console.log('hoursToWork', hoursToWork)
    const daysToWork = form.getValues().workDays;
    let aux_dias_permitidos: any = null;
    if (hoursToWork && daysToWork) {
      aux_dias_permitidos = await getDiasPermitidos(hoursToWork, daysToWork)
    }


    ///* upd
    if (editCanalVenta?.id_canal_venta) {
      return updateCanalVentaMutation.mutate({
        id: editCanalVenta.id_canal_venta,
        data: {
          ...form.getValues() as any,
          dias_permitidos: aux_dias_permitidos
        }, // desc?
      });
    }

    ///* create
    return createCanalVentaMutation.mutate({
      nombre: data.nombre,
      codigo: data.codigo,
      estado: data.estado,
      supervisor: data?.supervisor || (null as any),
      dias_permitidos: aux_dias_permitidos
    });
  };

  ///* effects
  useEffect(() => {
    if (!editCanalVenta?.id_canal_venta) return;
    const [horaInicio, horaFin] = getTimesForClockInWorkSchedules(editCanalVenta.dias_permitidos?.[0]?.horas!)
    setShrink(true);
    reset({
      ...editCanalVenta,
      estado: !!editCanalVenta.estado ? '1' : '0',
      workDays: editCanalVenta.dias_permitidos?.map((item: any) => item.dia),
      hora_inicio_jornada: horaInicio!,
      hora_fin_jornada: horaFin!,
    } as any);
  }, [editCanalVenta]);

  // // alerts
  // useEffect(() => {
  //   if (isLoadingSupervisores || isRefetchingSupervisores) return;

  //   if (!supervisoresPagingRes?.data?.data?.length) {
  //     setAlert(true, 'No se encontraron supervisores', AlertSeverityEnum.info);
  //   }
  // }, [isLoadingSupervisores, isRefetchingSupervisores, supervisoresPagingRes]);

  // useLoaders(isLoadingSupervisores || isRefetchingSupervisores);

  const auxDias = editCanalVenta?.dias_permitidos?.map((item: any) => item.dia)
  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCanalesVenta);
      }}
      onSave={handleSubmit(onSave, (error) => {
        console.log({ error })
      })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
        size={gridSizeMdLg6}
      />
      <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
        disabled={!!editCanalVenta}
      />

      {/* <CustomAutocomplete<Empleado>
        label="Supervisor"
        name="supervisor"
        // options
        options={supervisoresPagingRes?.data?.data || []}
        valueKey="razon_social"
        actualValueKey="codigo"
        defaultValue={form.getValues().supervisor || ''}
        isLoadingData={isLoadingSupervisores || isRefetchingSupervisores}
        // validation
        control={form.control}
        error={errors.supervisor}
        helperText={errors.supervisor?.message}
        required={false}
      /> */}

      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />



      {/* ---------- Horarios --------- */}
      <TabTextLabel text="Horario de Empleado" pt="39px" pb="3px" />
      <SampleCheckbox
        label="Disponible 24/7"
        name="siempre_disponible"
        control={form.control}
        defaultValue={!!form.getValues().siempre_disponible}
        onChangeValue={v => form.reset({
          ...form.getValues(),
          siempre_disponible: v,
        })}
      />
      {
        !form.getValues().siempre_disponible ?
          <>
            <AcutocompletePromocion<WorkDaysCollection>
              label="Días laborales"
              name="workDays"
              textFieldKey="workDays"
              valueKey="nombreDia"
              actualValueKey="dia"
              // options
              options={DAYS_WEEK_COLLECTION?.data || []}
              defaultValue={
                // avoid error reference
                DAYS_WEEK_COLLECTION?.data.filter((item: WorkDaysCollection) =>
                  auxDias?.includes(item.dia!))
              }
              isLoadingData={false}
              // errors
              control={form.control}
              error={!!errors.workDays}
              helperText={errors.workDays?.message}
              onChangeRawValue={v => {
                form.setValue(
                  'workDays',
                  v?.map((item: WorkDaysCollection) => item?.dia!)
                );
              }}
            />
            <TimeClockComponente
              size={gridSizeMdLg6}
              control={form.control}
              error={errors.hora_inicio_jornada}
              // helperText={""}//errors.hora_inicio?.message}
              label='Hora de inicio jornada'
              name='hora_inicio_jornada'
              enableDateTypeResult={true}
            />
            <TimeClockComponente
              size={gridSizeMdLg6}
              control={form.control}
              error={errors.hora_fin_jornada}
              // helperText={""}//errors.hora_inicio?.message}
              label='Hora de fin jornada'
              name='hora_fin_jornada'
              enableDateTypeResult={true}
            />
          </>
          : null
      }
    </SingleFormBoxScene>
  );
};

export default SaveCanarVenta;
